/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import clsx from 'clsx';
import { Row, Col, Image, Space } from "antd";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import DropDown from "../../../../../assets/images/icon_menus/Drop Down.svg";
import DropUp from "../../../../../assets/images/icon_menus/Drop Up.svg";
import { NavLink, useParams } from "react-router-dom";
import { TextField } from "@mui/material";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { useDispatch, useSelector } from "react-redux";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../../../Shared/components/Icons/Date";
import { ListTable } from "./ListTable";
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import managementActions from "../../../Management/redux/actions";
import gstActions from "../../../../Admin/Setup/redux/actions";
import { FilterSelect } from "../../../../Shared/components/CustomSelect";
import crudActions from "../../../../CRUD/redux/actions";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import moment from 'moment';
import setUpActions from "../../../../YounoteAdmin/Setup/redux/actions";
import { checkViewPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import dayjs from 'dayjs';
import { AESDecrypt } from "../../../../../helpers/Crypto";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const PurchaseInvoiceHistory = (props) => {
    const { supplierDetails } = useSelector(state => state.purchaseManagementReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { productGstdetails } = useSelector(state => state.adminSetupReducer);
    const { purchaseInvoiceDetails, loader } = useSelector(state => state.purchaseTransactionsReducer);
    const [dateValue, setDateValue] = useState([null, null]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [picker, setPicker] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const prevSearch = usePrevious(search);
    const [sortBy, setSortBy] = useState("id");
    const [dataSettle, setDataSettle] = useState("un-paid");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const timeoutRef = useRef(null);
    // const searchInput = useRef(null);
    const { invoiceSupplierID } = useParams();
    const decryptedId = AESDecrypt(invoiceSupplierID);
    const [supplierId, setSupplierId] = useState(decryptedId ? decryptedId : '');

    const { getList, getData } = useSelector(state => state.crudReducer);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const { overDue } = useParams();

    const [importVisible, setImportVisible] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    const onSelected = (data) => {
    }

    const supllierObject = () => {
        let a = supplierDetails && supplierDetails.filter(function (el) { return el.id === parseInt(supplierId) });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFillter(supplierId, dateValue, dataSettle);
            } else {
                timeoutRef.current = setTimeout(() => {
                    dispatchFillter(supplierId, dateValue, dataSettle);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Supplier Invoice History', history, 'Purchase')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFillter = (supplierId = '', dateValue = [null, null], dataSettle = '', skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (supplierId !== '') {
            filter['and'].push({ supplierId: supplierId });
        }

        if (search !== '') {
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ supplierName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ invoiceAmount: { like: '%' + search.trim() + '%' } });
        }
        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ invoiceDate: { between: [dayjs(dateValue[0]).format('YYYY-MM-DD'), dayjs(dateValue[1]).format('YYYY-MM-DD')] } });
        }

        if (overDue !== undefined) {
            filter['and'].push({ dueDate: { lt: moment().format('YYYY-MM-DD') } });
        }


        if (dataSettle !== '') {
            if (dataSettle === 'paid') {
                // let createfilter = {
                //     ["or"]: [
                //         { ["and"]: [{ isSettled: true }, { billStatus: "CREATED" }] },
                //         { ["and"]: [{ isSettled: true }, { billStatus: "REVERSED" }] },
                //         { ["and"]: [{ isSettled: false }, { billStatus: "CANCELLED" }] }]
                // };

                let createfilter = {
                    ["or"]: [
                        { ["and"]: [{ billStatus: "CONFIRMED" }] },
                        { ["and"]: [{ billStatus: "REVERSED" }] },
                        { ["and"]: [{ isSettled: true }, { billStatus: "CREATED" }] },
                        { ["and"]: [{ billStatus: "CANCELLED" }] }]
                };

                filter['and'].push(createfilter);
            } else {
                filter['and'].push({ isSettled: false }, { billStatus: "CREATED" });
            }
        }
        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        timeoutRef.current = null;
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'purchaseInvoice',
            skip: skip,
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        })
    }

    const loadTasks = useCallback(() => {
        var filter = {};
        if (invoiceSupplierID !== undefined) {
            setSupplierId(decryptedId);
            filter["supplierId"] = decryptedId
        }
        dispatch({ type: setUpActions.REJECT_DETAILS_START });
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, url: 'productgst', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: managementActions.SUPPLIER_DETAILS_START, url: 'supplierProfile', filter: {
                order: 'id desc'
            }
        });
        dispatchFillter(decryptedId === 0 ? '' : decryptedId, dateValue, dataSettle);
    });

    const handleChangeSupplier = (value) => {
        setSupplierId(value);
        dispatchFillter(value, dateValue, dataSettle);
    }

    const handleDates = (value, reset = false) => {
        setDateValue(value);
        if ((value[0] !== null && value[1] !== null) || reset) {
            dispatchFillter(supplierId, value, dataSettle);
        }
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFillter(supplierId, dateValue, dataSettle);
    }

    const handlePicker = (picker) => {
        setPicker(picker);
        setStartDate(null);
        setEndDate(null);
        if (!picker) {
            handleDates([null, null], true);
        }
    }

    const handleSettle = (value) => {
        setDataSettle(value);
        dispatchFillter(supplierId, dateValue, value);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFillter(supplierId, dateValue, dataSettle, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (supplierId !== '') {
            filter['and'].push({ supplierId: supplierId });
        }

        if (search !== '') {
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ supplierName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ invoiceAmount: { like: '%' + search.trim() + '%' } });
        }
        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ invoiceDate: { between: [dayjs(dateValue[0]).format('YYYY-MM-DD'), dayjs(dateValue[1]).format('YYYY-MM-DD')] } });
        }

        if (overDue !== undefined) {
            filter['and'].push({ dueDate: { lt: moment().format('YYYY-MM-DD') } });
        }


        if (dataSettle !== '') {
            if (dataSettle === 'paid') {
                let createfilter = { ["or"]: [{ ["and"]: [{ isSettled: true }, { billStatus: "CREATED" }] }, { ["and"]: [{ isSettled: true }, { billStatus: "REVERSED" }] }, { ["and"]: [{ isSettled: false }, { billStatus: "CANCELLED" }] }] };

                filter['and'].push(createfilter);
            } else {
                filter['and'].push({ isSettled: false }, { billStatus: "CREATED" });
            }
        }
        filter['and'].push(or);
        dispatch({
            type: actions.PURCHASE_INVOICE_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'purchaseInvoice',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    // const handleChange = (e) => {
    //     if (e.target.value === '') {
    //         handleChangeSupplier('');
    //     }
    // }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props} img={PurchaseIcon}
                title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'Supplier Invoice History', 'link': '' }]} />

            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Supplier Invoice History'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={14} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Inv. No., Name and, Inv. Amount'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                onChange={(e) => setSearch(e.target.value)}
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'supplierInvoiceHistory', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={10} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent, classes.removeUnderline, classes.customerLabelNone)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Action', 'All Customer') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Suppliers "}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={supplierDetails}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    id={idNamingConversion('All Suppliers', 'supplierInvoiceHistory', 'DropDown')}
                                                    customClasses={classes.customWidth172P}
                                                    parentValue={supllierObject()}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            handleChangeSupplier(data);
                                                        }
                                                    }}
                                                    onChange={(data) => handleChangeSupplier(data.id)}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Action', 'Date Filter') &&
                                                <div className={clsx(classes.dateFilterwidth, classes.width250)}>
                                                    <Row>
                                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                            <NavLink id={idNamingConversion('Date Filter', 'supplierInvoiceHistory', 'Link')} to={'#'} onClick={() => handlePicker(!picker)} className={clsx(classes.textAlignLeft, classes.dateFilter, classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}>
                                                                Date Filter <Image
                                                                    src={picker ? DropUp : DropDown}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        </Col>
                                                        {
                                                            picker && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <div className={clsx(classes.dateFilterdateAdjust)}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            allowKeyboardControl={false}
                                                                            value={startDate}
                                                                            label="From Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,

                                                                                },
                                                                                // inputProps: { value: moment(startDate).format('DD/MM/YYYY'), readOnly: false }
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue) => {
                                                                                handleDates([moment(newValue).format("YYYY-MM-DD"), endDate]);
                                                                                setStartDate(newValue);
                                                                            }}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    id: idNamingConversion('From Date', 'supplierInvoiceHistory', 'TextField'),
                                                                                    autoComplete: 'one-time-code'
                                                                                },
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            allowKeyboardControl={false}
                                                                            value={endDate}
                                                                            minDate={new Date(startDate)}
                                                                            label="To Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor,

                                                                                },
                                                                                //inputProps: { value: moment(endDate).format('DD/MM/YYYY'), readOnly: false }
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue) => {
                                                                                handleDates([startDate, moment(newValue).format("YYYY-MM-DD")]);
                                                                                setEndDate(newValue);
                                                                            }}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    id: idNamingConversion('To Date', 'supplierInvoiceHistory', 'TextField'),
                                                                                    autoComplete: 'one-time-code'
                                                                                },
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </div>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Action', 'Paid') &&
                                                <FilterSelect
                                                    parentClasses={clsx(classes.dateFilterwidth, classes.width125)}
                                                    customClasses={clsx(classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}
                                                    details={[{ slug: "", label: "All" }, { slug: "paid", label: "Paid" }, { slug: "un-paid", label: "Un-paid" }]}
                                                    onChange={(e) => handleSettle(e.target.value)}
                                                    defaultValue={dataSettle}
                                                    heads={['slug', 'label']}
                                                    id={idNamingConversion('All', 'supplierInvoiceHistory', 'DropDown')}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'supplierInvoiceHistory', 'Link')}
                                                    onClick={() => { loadImportExportData('PurchaseInvoice'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                supplierId={supplierId}
                                onSelected={onSelected}
                                dateValue={dateValue}
                                overDue={overDue}
                                dataSettle={dataSettle}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                loadTasks={() => dispatchFillter(supplierId, dateValue, dataSettle)}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                productGstdetails={productGstdetails}
                                businessDetails={businessDetails}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                            />
                        </>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'PurchaseInvoice'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={purchaseInvoiceDetails}
                loadTasks={() => { dispatchFillter(sortBy, sortOrder) }}
            />
        </React.Fragment >
    )
}
export default PurchaseInvoiceHistory